<template>
  <div>
    <div class="d-flex align-items-center">
      <h5 class="mr-3">¿Qu&eacute; son los observadores?</h5>
      <vs-button class="p-3" icon-after icon="info" @click="$refs.observersInfo.show()">
        Explicaci&oacute;n
      </vs-button>
      </div>
    <b-modal
      title="Observadores"
      size="lg"
      centered
      no-close-on-backdrop
      hide-footer
      ref="observersInfo"
    >
      <p>
        Un observador es una persona que <b>no es participante activo</b> del flujo
        de aprobaci&oacute;n, pero que puede acceder a consultar sobre ese documento
        y todo lo que se comente. Esto aplica tambi&eacute;n para un archivo que se
        agrega durante el ciclo de vida de la aprobaci&oacute;n de un documento.
      </p>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: 'ObserversInfo'
};
</script>
